import React, { useState, useEffect } from "react";
import Header from "../components/header/Header";
import "../components/css/reports.css";
import downArrow from "../images/arrow-down.svg";
import whiteArrow from "../images/white-arrow.svg";
import smallArrow from "../images/small_arrow.svg";
import smallWhite from "../images/smallWhite.svg";
import { Link } from "react-router-dom";
// import FooterMenu from "../components/FooterMenu/FooterMenu";
import { keyContext } from "../components/KeyContext";
import { useContext } from "react";
import Dagens from "./Dagens";
import UgesRapport from "./WeekReport";
import Dagperiode from "./DayPeriode";
import PeriodeSam from "./PeriodeSam";
import WorkPlan from "./WorkPlan";
import arrow from "../images/icon-arrow.png";

// import Test from "./Test";
import { useNavigate } from "react-router-dom";
import BilletsalgPerFilm from "./TicketSell";
import AdminIncidents from "./AdminIncidents";
import SideMenus from "../components/SideMenus";
import FourWeeksReport from "./FourWeeksReport";

function Reports({ pageView }) {
  const { open, isChecked, weekBoxOpen, setContainerHeight, setLeftSpace } =
    useContext(keyContext);
  // const [show, setShow] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [dagsIsActive, setDagsIsActive] = useState(false);
  const [isShown, setIsShown] = useState(false);
  const [dagsIsShown, setdagsIsShown] = useState(false);
  const [rights, setRights] = useState([{}]);
  let key = sessionStorage.getItem("key");
  let orgID = sessionStorage.getItem("orgID");

  const theme = localStorage.getItem("theme");

  function openReports() {
    setIsShown((current) => !current);
  }

  const navigate = useNavigate();

  useEffect(() => {
    const endpoint = `https://biograf.ebillet.dk/systemnative/report.asmx/man_getaccessrights?Key=${key}&LoginNo=${orgID}`;
    if (key && orgID) {
      fetch(endpoint, {
        method: "GET",
        headers: {
          ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
        },
      })
        .then((res) => res.json())
        .then((result) => {
          // console.log(result)
          if (result.result === 0) {
            //navigate("/");
          }
          setRights(result);
        });
    }
  }, [key, orgID]);

  const storedPageKey = sessionStorage.getItem("pageKey");
  const reportChecked = localStorage.getItem("reportChecked");

  // console.log(storedPageKey)

  function handlePageKey() {
    sessionStorage.setItem("pageKey", "a");
  }
  const [pageKey, setPageKey] = React.useState("x");

  useEffect(() => {
    rights &&
      rights.map((right, index) => {
        if (right.name === "ACC_DAYREVENUE") {
          sessionStorage.setItem("pageKey", pageKey);
        }
      });

    // sessionStorage.setItem('pageKey', pageKey)
  }, [pageKey]);
  // console.log(pageKey, 'page key')
  useEffect(() => {
    rights &&
      rights.map((right, index) => {
        if (right.name === "ACC_DAYREVENUE") {
          return setPageKey(storedPageKey ? storedPageKey : "e");
        }
      });
  }, [rights]);

  const Menu = (props) => {
    return (
      <div id="meu" className="has-scrollbar" style={{ marginLeft: "16px" }}>
        <button
          style={{
            border: "none",
            background: "transparent",
            color:
              pageKey === "z" && theme === "dark"
                ? "#ecc590"
                : pageKey === "z" && theme !== "dark"
                ? "#982f2f"
                : pageKey !== "z" && theme === "dark"
                ? "white"
                : "#101010",
            marginBottom: 6 + "px",
            fontWeight: pageKey === "z" ? "bold" : "normal",
          }}
          onClick={() => {
            props.onClick("z");
          }}
        >
          Billetsalg pr. uge{" "}
        </button>
        {reportChecked === "true" ? (
          ""
        ) : (
          <button
            style={{
              border: "none",
              marginBottom: 6 + "px",
              background: "transparent",
              color:
                pageKey === "b" && theme === "dark"
                  ? "#ecc590"
                  : pageKey === "b" && theme !== "dark"
                  ? "#982f2f"
                  : pageKey !== "b" && theme === "dark"
                  ? "white"
                  : '"101010',
              fontWeight: pageKey === "b" ? "bold" : "normal",
            }}
            onClick={() => {
              props.onClick("b");
            }}
          >
            Billetsalg pr. forestilling{" "}
          </button>
        )}
        <button
          style={{
            border: "none",
            marginBottom: 6 + "px",
            background: "transparent",
            color:
              pageKey === "k" && theme === "dark"
                ? "#ecc590"
                : pageKey === "k" && theme !== "dark"
                ? "#982f2f"
                : pageKey !== "k" && theme === "dark"
                ? "white"
                : '"101010',
            fontWeight: pageKey === "k" ? "bold" : "normal",
          }}
          onClick={() => {
            props.onClick("k");
          }}
        >
          {" "}
          Fireugersrapport
        </button>
      </div>
    );
  };

  let page;
  switch (pageKey) {
    case "z":
      page = <UgesRapport setIsShown={setIsShown} />;
      break;
    case "k":
      page = <FourWeeksReport setIsShown={setIsShown} />;
      break;
    case "b":
      page = <BilletsalgPerFilm setIsShown={setIsShown} />;
      break;

    case "c":
      page = <Dagperiode />;
      break;

    case "d":
      page = <Dagperiode />;
      break;

    case "e":
      page = <Dagens />;
      break;

    case "f":
      page = <PeriodeSam />;
      break;

    case "x":
      page = <WorkPlan />;
      break;

    default:
      page =
        rights &&
        rights.map((right, index) => {
          if (right.name === "ACC_DAYREVENUE")
            return (
              <div className="men" key={index}>
                <Dagens />
              </div>
            );
        });

      break;
  }

  const DagsMenu = (props) => {
    return (
      <div>
        <button
          style={{
            border: "none",
            paddingTop: "2px",
            marginBottom: 6 + "px",
            background: "transparent",
            color:
              pageKey === "c" && theme === "dark"
                ? "#ecc590"
                : pageKey === "c" && theme !== "dark"
                ? "#982f2f"
                : pageKey !== "c" && theme === "dark"
                ? "white"
                : "#101010",
            fontWeight: pageKey === "c" ? "bold" : "normal",
          }}
          onClick={() => {
            props.onClick("c");
          }}
        >
          {" "}
          Dagsperioder
        </button>

        {/* <button style={{border:'none',marginBottom: 6 + 'px',  background:'transparent' , color: pageKey === 'd'  ? "#982f2f" : "black", marginLeft:'8px'}} onClick={() => {props.onClick("d") } }> Dagsperioder pr. dag</button>  */}
      </div>
    );
  };

  const DagensMenu = (props) => {
    return (
      <button
        style={{
          border: "none",
          marginBottom: 6 + "px",
          textAlign: "left",
          paddingTop: "2px",
          background: "transparent",
          color:
            pageKey === "e" && theme === "dark"
              ? "#ecc590"
              : pageKey === "e" && theme !== "dark"
              ? "#982f2f"
              : pageKey !== "e" && theme === "dark"
              ? "white"
              : "#101010",
          fontWeight: pageKey === "e" ? "bold" : "normal",
        }}
        onClick={() => {
          props.onClick("e");
        }}
      >
        Dagens omsætning
      </button>
    );
  };

  const PeriodeMenu = (props) => {
    return (
      <button
        style={{
          border: "none",
          marginBottom: 6 + "px",
          textAlign: "left",
          paddingTop: "2px",
          background: "transparent",
          color:
            pageKey === "f" && theme === "dark"
              ? "#ecc590"
              : pageKey === "f" && theme !== "dark"
              ? "#982f2f"
              : pageKey !== "f" && theme === "dark"
              ? "white"
              : "#101010",
          fontWeight: pageKey === "f" ? "bold" : "normal",
        }}
        onClick={() => {
          props.onClick("f");
        }}
      >
        Periodesammenligninger
      </button>
    );
  };

  const WorkMenu = (props) => {
    return (
      <button
        style={{
          border: "none",
          paddingTop: "2px",
          textAlign: "left",
          background: "transparent",
          color:
            pageKey === "x" && theme === "dark"
              ? "#ecc590"
              : pageKey === "x" && theme !== "dark"
              ? "#982f2f"
              : pageKey !== "x" && theme === "dark"
              ? "white"
              : "#101010",
          fontWeight: pageKey === "x" ? "bold" : "normal",
        }}
        onClick={() => {
          props.onClick("x");
        }}
      >
        Arbejdsplan
      </button>
    );
  };
  useEffect(() => {
    let elem = document.getElementById("reports");
    let rect = elem.getBoundingClientRect();
    setLeftSpace(rect.x);
    setContainerHeight(document.getElementById("reports").clientHeight);
  }, []);

  return (
    <main className="containers">
      <Header isActive="active" />

      <div
        className="reports"
        id="reports"
        style={{
          backgroundColor: open ? "rgba(0,0,0,0.7)" : "",
          opacity: open ? "0.1" : "",
        }}
      >
        <aside className="side-menu">
          {/* <Link to="/dagsperiode">gg</Link> */}
          {/* <Link
                            to="/rapport"
                            style={{ textDecoration: "none", color: "black" }}
                          >
                            <p style={{ paddingLeft: 10 }}>
                              Ugestatestikrapporter
                            </p>{" "}
                          </Link>
                          <Link
                            to="/workplans"
                            style={{ textDecoration: "none", color: "black" }}
                          >
                            <p style={{ paddingLeft: 10 }}>Arbejdsplan</p>{" "}
                          </Link>        */}
          {/* <SideMenus pages={page}/> */}

          {rights &&
            rights.map((right, index) => {
              if (right.name === "ACC_COMPAREPERIODS")
                return (
                  <div
                    className="men"
                    key={index}
                    style={{
                      border: theme === "dark" ? "1px solid #6c6c6c" : "",
                      backgroundColor: theme !== "dark" ? "white" : "",
                      marginBottom: "4px",
                    }}
                  >
                    <PeriodeMenu onClick={setPageKey} />
                  </div>
                );
            })}

          {rights &&
            rights.map((right, index) => {
              if (right.name === "ACC_WEEKSTAT")
                return (
                  <>
                    <div
                      className="reportsTitles"
                      style={{
                        color:
                          (pageKey === "z" || pageKey === "b") &&
                          theme === "dark"
                            ? "#ecc590"
                            : (pageKey === "z" || pageKey === "b") &&
                              theme !== "dark"
                            ? "#982f2f"
                            : pageKey !== "z" && theme === "dark"
                            ? "white"
                            : "#101010",
                        marginBottom: "5px",
                        fontWeight:
                          (pageKey === "z" || pageKey === "b") && "bold",
                        border: theme === "dark" ? "1px solid #6c6c6c" : "",
                        backgroundColor:
                          theme !== "dark"
                            ? "white"
                            : isShown && theme !== "dark"
                            ? "#982f2f"
                            : "",
                        height: "42px",
                      }}
                    >
                      <span style={{ lineHeight: "20px" }}>
                        Ugestatistikrapporter
                      </span>
                      <img
                        src={theme === "dark" ? smallWhite : smallArrow}
                        onClick={openReports}
                        style={{
                          rotate: isShown ? "180deg" : "",
                          marginRight: "10px",
                          cursor: "pointer",
                          borderBottom: isShown ? "none" : "",
                          height: "15px",
                          marginTop: "5px",
                        }}
                        alt="arrow"
                      />
                    </div>
                    {isShown && (
                      <div className="side-submenu" style={{}}>
                        <Menu onClick={setPageKey} />
                      </div>
                    )}
                  </>
                );
            })}

          {rights &&
            rights.map((right, index) => {
              if (right.name === "ACC_DAYPERIODS")
                return (
                  <div
                    className="men"
                    key={index}
                    style={{
                      border: theme === "dark" ? "1px solid #6c6c6c" : "",
                      backgroundColor: theme !== "dark" ? "white" : "",
                      marginBottom: "4px",
                    }}
                  >
                    <DagsMenu onClick={setPageKey} />
                  </div>
                );
            })}

          {dagsIsShown && (
            <div className="">
              <DagsMenu onClick={setPageKey} />
            </div>
          )}

          {rights &&
            rights.map((right, index) => {
              if (right.name === "ACC_DAYREVENUE")
                return (
                  <div
                    className="men"
                    key={index}
                    style={{
                      border: theme === "dark" ? "1px solid #6c6c6c" : "",
                      backgroundColor: theme !== "dark" ? "white" : "",
                      marginBottom: "4px",
                    }}
                  >
                    <DagensMenu onClick={setPageKey} />
                  </div>
                );
            })}

          {/* {rights &&
            rights.map((right, index) => {
              if (right.name === "ACC_WEEKSTAT")
                return (
                  <div className="men" key={index}>
                    <Menu onClick={setPageKey} />
                  </div>
                );
            })} */}

          {rights &&
            rights.map((right, index) => {
              if (right.name === "ACC_WORKPLAN")
                return (
                  <div
                    className="men"
                    key={index}
                    style={{
                      border: theme === "dark" ? "1px solid #6c6c6c" : "",
                      backgroundColor: theme !== "dark" ? "white" : "",
                    }}
                  >
                    <WorkMenu onClick={setPageKey} />
                  </div>
                );
            })}
        </aside>

        <div className="main-menu">{page}</div>
      </div>
    </main>
  );
}

export default Reports;
